/**
 * sets ERROR container height so without content it has at least the height required to force FOOTER to be on the bottom of the screen viewport not right bellow latest article with grey backgound covering the rest of the PAGE
 */
export function errorContainerHeight() {
    // inner window height - our reference point
    let windowHeight = window.innerHeight;

    // footer height - this also needs to be substracted from WINDOW height
    let footer = document.getElementById("footer");
    let footerHeight = 0;
        
    // total height to be substracted from WINDOW height
    let totalHeight = 0
    if(footer !== null) {
        footerHeight = footer.offsetHeight * 0.8;
        totalHeight = (windowHeight - footerHeight)*1.25;
    };
        
    // our final container size
    let page404Container = document.getElementById("page404Container");
    if(page404Container !== null) {
        page404Container.style.height = String(totalHeight) + "px";
    }     
};